<template>
  <div>
    <common-dialog ref="dialog" width="800px" :title="title">
      <list ref="list">
        <el-table-column slot="column" label="操作" fixed="right" align="center" :width="$store.state.isMB?'60':'100'">
          <template slot-scope="{row}">
            <el-button @click="onSelect(row)" type="text">选择</el-button>
          </template>
        </el-table-column>
      </list>
    </common-dialog>

    <!-- <el-dialog ref="dialog" width="900px" :title="title" :visible.sync="visible" @close="onClose"
      @open="onOpen"></el-dialog> -->
  </div>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./list";
import listDialogMixins from "@/mixins/listDialog";

export default {
  mixins: [listDialogMixins],
  components: {
    commonDialog,
    list
  },
  props: {
    title: {
      type: String,
      default: "菜单列表"
    }
  }
  // data() {
  //   return {
  //     visible: false
  //   };
  // },
  // methods: {
  //   open() {
  //     this.visible = true;
  //     // this.$refs.list.getData();
  //     // console.log("openList");
  //   },
  //   onClose() {
  //     // console.log("close");
  //   },
  //   onOpen() {
  //     // console.log("open");
  //   }
  // }
};
</script>